import { css } from '@emotion/react';
import { math } from 'polished';

import { BorderRadius, BorderTopRadius } from './mixins/_border-radius.mixin';
import { FontSize } from './vendor/_rfs.mixin';
import { subtract } from './_functions';


export default $ => css`
  .toast {
    flex-basis: ${$.toastMaxWidth};
    max-width: ${$.toastMaxWidth};
    ${new FontSize($.toastFontSize).include($)};
    color: ${$.toastColor};
    background-color: ${$.toastBackgroundColor};
    background-clip: padding-box;
    border: ${$.toastBorderWidth} solid ${$.toastBorderColor};
    box-shadow: ${$.toastBoxShadow};
    opacity: 0;
    ${new BorderRadius($.toastBorderRadius).include($)};

    &:not(:last-child) {
      margin-bottom: ${$.toastPaddingX};
    }

    &.showing {
      opacity: 1;
    }

    &.show {
      display: block;
      opacity: 1;
    }

    &.hide {
      display: none;
    }
  }

  .toast-header {
    display: flex;
    align-items: center;
    padding: ${$.toastPaddingY} ${$.toastPaddingX};
    color: ${$.toastHeaderColor};
    background-color: ${$.toastHeaderBackgroundColor};
    background-clip: padding-box;
    border-bottom: ${$.toastBorderWidth} solid ${$.toastHeaderBorderColor};
    ${new BorderTopRadius(subtract($.toastBorderRadius, $.toastBorderWidth)).include($)};
  }

  .toast-body {
    padding: ${$.toastPaddingX};
  }
`;
